import { createFileRoute } from "@tanstack/react-router"

import cliffsSrc from "@/assets/home-new/panels/cliffs.avif"
import { marketingPages } from "@/lib/marketing-pages"
import { seoMeta } from "@/lib/seo"

import { PricingPage } from "./-components/PricingPage"

export const Route = createFileRoute("/pricing/")({
  head: () =>
    seoMeta({
      title: "Pricing",
      description: marketingPages["/pricing"].description,
      url: "https://entire.com/pricing",
      image: "/images/og/pricing.png",
      imageAlt: "Entire pricing",
      // The card's art panel is above the fold, so its image loads with the
      // page rather than after the route's code.
      extraLinks: [
        { rel: "preload", as: "image", href: cliffsSrc, type: "image/avif", fetchPriority: "high" },
      ],
    }),
  component: PricingPage,
})
